import {inputBaseClasses, styled, TextField} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/material.css'

const CustomTextField = styled(TextField)(({theme}) => ({
    "& .special-label": {display: "none!important"},
    "& .react-tel-input": {fontFamily: "inherit"},
    "& .react-tel-input .country-list": {
        background: theme.palette.background.box,
        "& .country:hover, .country.highlight": {
            color: '#424242'
        }
    },
    [`& .${inputBaseClasses.input}`]: {
        padding: 0,
        height: "auto",
        "& input": {
            fontFamily: "inherit",
            fontSize: ".875rem",
            width: '100%',
            height: '100%',
            color: "inherit",
            background: "inherit",
            border: "none!important",
            boxShadow: "none!important",
            "&::placeholder": {
                fontSize: ".855rem",
            }
        }
    },
}));

const PhoneTextField = (props) => {
    return <CustomTextField {...props} InputProps={{ inputComponent: PhoneInput, ...props.InputProps }} inputProps={{ specialLabel: null, inputProps: props.inputProps, ...props.inputProps }}/>
}
export default PhoneTextField;